<div class="container">
<div class="info-box">

  <div class="imgdiv">
    <div class="imgholder"></div>
    <div></div>
  </div>
  <div class="content">
    {{message}}

  </div>
</div>
</div>
